import { AlertTriangle } from "lucide-react";
import { formatDateTime } from "@/lib/format";

function noticeText(status) {
  if (status.state === "not_configured") {
    return "Webshop-koppeling nog niet ingesteld — de getoonde gegevens zijn voorbeeldgegevens.";
  }
  if (status.state === "error") {
    const last = status.last_success ? ` Laatste geslaagde update: ${formatDateTime(status.last_success)}.` : "";
    return `Bijwerken vanuit kipkruiden.nl mislukt: ${status.error_message}${last}`;
  }
  return null;
}

export function SyncNotice({ status }) {
  if (!status) return null;
  const text = noticeText(status);
  if (!text) return null;
  return (
    <div data-testid="sync-notice" className="bg-status-low/15 border-b border-status-low/40 text-status-low">
      <div className="px-4 md:px-8 py-2 text-sm md:text-base font-medium flex items-center gap-2 justify-center text-center">
        <AlertTriangle className="w-4 h-4 shrink-0" />
        {text}
      </div>
    </div>
  );
}
